import React from 'react';
import { Link } from 'react-router-dom';

import './styles.css';

import UserPhoto from '../../UserPhoto';

export default function UserMenuLink(props){
  return(
    <Link to={props.to} className={'user-menu-link' + (props.selected ? ' selected' : '')}>
      <UserPhoto src={props.img}/>
      <div className='user-menu-link-texts'>
        <h3>{props.name}</h3>
        <p>{props.info}</p>
      </div>
    </Link>
  )
}